module.exports = __webpack_public_path__ + "img/fantasmagames.472baaaa.svg";